module.exports = __webpack_public_path__ + "img/august_900_page.9b3b4cca.png";